export default __webpack_public_path__ + "static/media/photo-active.3c77eded.svg";